/* TWS Hero carousel — 3D deck. Static asset; initialises every [data-hero-carousel]
   on the page. Covers are laid out in real 3D by their distance from the active
   one; advancing flips forward through the stack. GPU-composited (transform+opacity
   only). Mirrors design-system/ui_kits/website/index.html hero carousel. */
(function () {
  var POSE = {
    0:    { t: 'translate3d(0,0,0) rotateY(0deg) scale(1)',                o: 1,   z: 40 },
    1:    { t: 'translate3d(58px,12px,-150px) rotateY(-26deg) scale(.9)',  o: .72, z: 30 },
    2:    { t: 'translate3d(98px,24px,-290px) rotateY(-30deg) scale(.8)',  o: .4,  z: 20 },
    prev: { t: 'translate3d(-150px,-8px,-70px) rotateY(36deg) scale(.9)',  o: 0,   z: 10 },
    far:  { t: 'translate3d(112px,30px,-380px) rotateY(-32deg) scale(.76)', o: 0,  z: 1 }
  };
  function reduceMotion() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  function initCarousel(root) {
    var covers = Array.prototype.slice.call(root.querySelectorAll('.hc-cover'));
    var caps   = Array.prototype.slice.call(root.querySelectorAll('.hc-cap'));
    var dotsBox = root.querySelector('[data-dots]');
    var count = covers.length;
    if (count < 2) return;
    var index = 0, timer = null;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4200;
    var dots = [];

    if (dotsBox) {
      for (var i = 0; i < count; i++) {
        var d = document.createElement('button');
        d.type = 'button'; d.className = 'hc-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('role', 'tab'); d.setAttribute('aria-label', 'Show book ' + (i + 1) + ' of ' + count);
        d.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        (function (n) { d.addEventListener('click', function () { stop(); go(n); start(); }); })(i);
        dotsBox.appendChild(d); dots.push(d);
      }
    }

    function layoutDeck() {
      var reduce = reduceMotion();
      for (var i = 0; i < count; i++) {
        var off = (i - index + count) % count;
        var p = POSE[off] || (off === count - 1 ? POSE.prev : POSE.far);
        var c = covers[i];
        if (reduce) { c.style.transform = 'none'; c.style.opacity = (off === 0) ? 1 : 0; }
        else { c.style.transform = p.t; c.style.opacity = p.o; }
        c.style.zIndex = p.z;
        c.classList.toggle('is-front', off === 0);
      }
    }
    function go(next) {
      if (next === index) return;
      index = next;
      layoutDeck();
      caps.forEach(function (cap, k) { cap.classList.toggle('is-active', k === index); });
      var bg = covers[index].getAttribute('data-bg');
      if (bg) root.style.backgroundColor = bg;
      dots.forEach(function (dot, k) { var on = k === index; dot.classList.toggle('is-active', on); dot.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
    function nextSlide() { go((index + 1) % count); }
    function start() { if (autoplay && !timer && !reduceMotion()) { timer = window.setInterval(nextSlide, interval); } }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    layoutDeck(); start();
  }

  function boot() { document.querySelectorAll('[data-hero-carousel]').forEach(initCarousel); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
